<template>
  <base-wrapper>
    <div class="space-y-5">
      <base-card title="Informasi Promo">
        <template #action>
          <div class="flex gap-2">
            <PromoStatusBadge v-if="promo.data.id" :product-promo="promo.data" />
            <PromoStatusBadge v-if="promo.data.id" type="export" append :product-promo="promo.data" />
          </div>
        </template>
        <div class="grid grid-cols-2 gap-5">
          <div class="col-span-2">
            <base-input
              type="text"
              label="Nama Promo"
              placeholder="Promo 12.12"
              inset
              required
              v-model="form.name"
            />
          </div>
          <div class="col-span-2">
            <base-input
              label="Detail Promo"
              placeholder="Contoh: Promo Akhir Tahun"
              tag="textarea"
              rows="5"
              inset
              required
              v-model="form.description"
            />
          </div>
          <div class="col-span-2 space-y-4">
            <h4 class="font-medium text-gray-900">
              Tanggal Promo Stockist Center
            </h4>
            <div class="grid grid-cols-2 gap-5">
              <base-input
                label="Tanggal Dimulai Promo"
                type="datetime-local"
                inset
                required
                v-model="form.sc_start_at"
              />
              <base-input
                label="Tanggal Berakhir Promo"
                type="datetime-local"
                inset
                required
                v-model="form.sc_finish_at"
              />
            </div>
          </div>
          <div class="col-span-2 space-y-4">
            <h4 class="font-medium text-gray-900">
              Tanggal Promo Stockist / Mitra
            </h4>
            <div class="grid grid-cols-2 gap-5">
              <base-input
                label="Tanggal Dimulai Promo"
                type="datetime-local"
                inset
                required
                v-model="form.stockist_start_at"
              />
              <base-input
                label="Tanggal Berakhir Promo"
                type="datetime-local"
                inset
                required
                v-model="form.stockist_finish_at"
              />
            </div>
          </div>
          <div class="col-span-2 space-y-4">
            <h4 class="font-medium text-gray-900">
              Tanggal Export Stok
            </h4>
            <base-input
              label="Tanggal Export Stok"
              type="datetime-local"
              inset
              required
              v-model="form.stock_export_at"
            />
          </div>
          <div class="col-span-2 flex justify-between">
            <base-button
              v-if="promo.data.id"
              color="danger"
              @click="onToggleSuspend"
              >{{
                promo.data.attributes.is_suspended ? 'Batal Suspend' : 'Suspend'
              }}</base-button
            >
            <base-button @click="onSave">Simpan</base-button>
          </div>
        </div>
      </base-card>
      <base-card
        v-if="promo.data.id"
        title="Isi Promo"
        description="Klik pada baris untuk menambahkan/mengubah isi promo"
      >
        <template #action>
          <div class="flex items-center gap-2">
            <base-input
              placeholder="Pencarian"
              type="text"
              :shadow="false"
              v-model="searchProductBundle"
              debounce
              @native-input="loadPromoBundles"
            />
            <div>
              <base-button
                type="submit"
                :class="[
                  importBundle.processing ? '' : 'rounded-r-none border-r-0',
                ]"
                :loading="importBundle.processing"
                @click="onOpenImportBundle"
                >{{
                  importBundle.processing ? 'Sedang Diproses' : 'Import Bundle'
                }}</base-button
              >
              <base-button
                v-if="!importBundle.processing"
                href="/import-bundle-example/bundle.csv"
                class="rounded-l-none border-l-green-700"
                >Contoh</base-button
              >
            </div>
            <base-button
              v-if="promo.data.attributes.stock_export_status === 'finished'"
              :loading="loadingDownloadStockExport"
              @click="onDownloadStockExport"
              >Download Stock Export</base-button
            >
          </div>
        </template>
        <datatable
          :columns="columns"
          :scroll-x="false"
          :total="productBundles.meta.page.total"
          :perPage="productBundles.meta.page.perPage"
          :currentPage="productBundles.meta.page.currentPage"
          @pagechanged="onPageBundleChanged"
        >
          <template #tbody="{ classes }">
            <tr
              v-for="productBundle in productBundles.data"
              :key="productBundle.id"
              :class="[
                classes.tr,
                'cursor-pointer bg-white hover:bg-green-100',
              ]"
              @click="onDetailProductBundle(productBundle)"
            >
              <td :class="classes.td">
                {{ productBundle.attributes.sort_order }}
              </td>
              <td :class="classes.td">
                <span class="font-bold text-gray-900">
                  {{ productBundle.attributes.name }}
                </span>
              </td>
              <td :class="classes.td">
                {{ productBundle.attributes.bundle_type_description }}
              </td>
            </tr>
          </template>
          <template #tfoot="{ classes }">
            <tr :class="[classes.tr, 'cursor-pointer']" @click="onCreateBundle">
              <td :class="classes.td" colspan="2">
                <div
                  class="flex items-center gap-x-2 font-medium text-gray-900"
                >
                  <Icon icon="heroicons:plus-20-solid" class="h-5 w-5" />
                  <span>Tambah Isi Promo</span>
                </div>
              </td>
            </tr>
          </template>
        </datatable>
      </base-card>
    </div>
    <ImportBundleModal
      :product-promo-id="promo.data.id"
      :visible="importBundle.visible"
      @close="importBundle.visible = false"
      @success="onProcessImportBundle"
    />
    <product-bundle-form-modal
      :visible="productBundleFormModal.visible"
      :product-promo="promo"
      :product-bundle-id="productBundleFormModal.productBundleId"
      @close="productBundleFormModal.visible = false"
      @created="onUpdatedBundle"
      @deleted="onUpdatedBundle"
    />
    <loading v-if="loadingPromo || loadingJobStatus || loadingPromoBundles" />
  </base-wrapper>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { requestMixin } from '@/mixins/request/request';
import ProductBundleFormModal from '@/components/promo/product-bundle/product-bundle-form-modal.vue';
import { formatDate, parseDate } from '@/utils/date';
import PromoStatusBadge from '../../../../../components/promo/PromoStatusBadge.vue';
import ImportBundleModal from '../../../../../components/promo/product-bundle/ImportBundleModal.vue';
import { downloadFile } from '@/services/utils.service';

export default {
  components: { ProductBundleFormModal, PromoStatusBadge, ImportBundleModal },
  computed: {
    ...mapGetters({
      me: 'auth/getUser',
      getChannelName: 'auth/getChannelName',
    }),
    columns() {
      return [
        { id: 'sort_order', name: 'No' },
        { id: 'name', name: 'Nama Bundle' },
        { id: 'type', name: 'Tipe Bundle' },
      ];
    },
    formParsed() {
      return {
        name: this.form.name,
        description: this.form.description,
        sc_start_at: parseDate(this.form.sc_start_at).format(
          'YYYY-MM-DDTHH:mm:ss'
        ),
        sc_finish_at: parseDate(this.form.sc_finish_at).format(
          'YYYY-MM-DDTHH:mm:ss'
        ),
        stockist_start_at: parseDate(this.form.stockist_start_at).format(
          'YYYY-MM-DDTHH:mm:ss'
        ),
        stockist_finish_at: parseDate(this.form.stockist_finish_at).format(
          'YYYY-MM-DDTHH:mm:ss'
        ),
        stock_export_at: !this.form.stock_export_at ? null : parseDate(this.form.stock_export_at).format(
          'YYYY-MM-DDTHH:mm:ss'
        )
      };
    },
  },
  data() {
    return {
      loadingPromo: false,
      loadingJobStatus: false,
      loadingPromoBundles: false,
      loadingDownloadStockExport: false,
      form: {
        name: null,
        description: null,
        sc_start_at: null,
        sc_finish_at: null,
        stockist_start_at: null,
        stockist_finish_at: null,
        stock_export_at: null
      },
      promo: {
        data: {
          id: null,
        },
      },
      productBundles: {
        data: [],
        meta: {
          page: {},
        },
      },
      productBundleFormModal: {
        visible: false,
        productBundleId: null,
      },
      importBundle: {
        processing: false,
        visible: false,
      },
      searchProductBundle: null,
    };
  },
  mixins: [requestMixin],
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    addListener() {
      const userChannel = this.$pusher.channel(this.getChannelName);

      userChannel.bind(
        'Illuminate\\Notifications\\Events\\BroadcastNotificationCreated',
        this.onProgressImportBundle
      );
    },
    async loadJobStatus() {
      this.loadingJobStatus = true;

      const [res, err] = await this.request(
        '/api/v1/users/-actions/check-job-status',
        {
          params: {
            type: 'import_promo_bundle',
          },
        }
      );

      if (!err) {
        const { running } = res;

        if (running) {
          this.importBundle.processing = true;
        }
      }

      this.loadingJobStatus = false;
    },
    async loadPromo(id) {
      this.loadingPromo = true;

      const [res, error] = await this.request(`/api/v1/product-promos/${id}`);

      if (!error) {
        this.setPromo(res);

        this.loadPromoBundles();
      }

      this.loadingPromo = false;
    },
    async loadPromoBundles(params) {
      this.loadingPromoBundles = true;

      const [res, error] = await this.request(
        `/api/v1/product-promos/${this.promo.data.id}/product-bundles`,
        {
          params: {
            'page[size]': 5,
            sort: 'sort_order',
            'filter[search]': this.searchProductBundle,
            ...params,
          },
        }
      );

      if (!error) {
        this.productBundles = res;
      }

      this.loadingPromoBundles = false;
    },
    onCreateBundle() {
      this.productBundleFormModal.visible = true;
      this.productBundleFormModal.productBundleId = null;
    },
    onUpdatedBundle() {
      this.searchProductBundle = null;
      this.loadPromo(this.$route.params.id);
    },
    async onToggleSuspend() {
      this.loadingPromo = true;

      const [, error] = await this.request(
        `/api/v1/product-promos/${this.promo.data.id}/-actions/toggle-suspend`,
        {
          method: 'patch',
        }
      );

      if (error) {
        this.createAlert({
          data: this.getRequestErrorMessage(error),
          status: 'error',
          type: 'confirm'
        });
      } else {
        this.createAlert({
          data: 'Promo berhasil diubah status suspend',
          status: 'success',
        });

        this.promo.data.attributes.is_suspended =
          !this.promo.data.attributes.is_suspended;
      }

      this.loadingPromo = false;
    },
    async onSave() {
      this.loadingPromo = true;

      if (this.promo.data.id) {
        const [, error] = await this.request(
          `/api/v1/product-promos/${this.promo.data.id}`,
          {
            method: 'patch',
            data: {
              data: {
                type: 'product-promos',
                id: this.promo.data.id,
                attributes: this.formParsed,
              },
            },
          }
        );

        if (error) {
          this.createAlert({
            data: this.getRequestErrorMessage(error),
            status: 'error',
            type: 'confirm'
          });
        } else {
          this.createAlert({
            data: 'Promo berhasil disimpan',
            status: 'success',
          });
        }
      } else {
        const [res, error] = await this.request('/api/v1/product-promos', {
          method: 'post',
          data: {
            data: {
              type: 'product-promos',
              attributes: this.formParsed,
            },
          },
        });

        if (error) {
          this.createAlert({
            data: this.getRequestErrorMessage(error),
            status: 'error',
            type: 'confirm'
          });
        } else {
          this.createAlert({
            data: 'Promo berhasil disimpan',
            status: 'success',
          });

          this.$router.push(res.data.id);

          this.setPromo(res);
        }
      }

      this.loadingPromo = false;
    },
    onDetailProductBundle(productBundle) {
      this.productBundleFormModal.visible = true;
      this.productBundleFormModal.productBundleId = productBundle.id;
    },
    onOpenImportBundle() {
      this.importBundle.visible = true;
    },
    onProcessImportBundle() {
      this.importBundle.processing = true;
      this.importBundle.visible = false;
    },
    onProgressImportBundle(e) {
      if (e.type === 'App\\Notifications\\ImportPromoBundleStatusUpdated') {
        if (e.status === 'processing') {
          this.importBundle.processing = true;
        } else {
          this.importBundle.processing = false;

          this.createAlert({
            status: 'success',
            data: 'Berhasil mengimport bundle',
          });

          this.loadPromo(this.promo.data.id);
        }
      }
    },
    onPageBundleChanged(page) {
      this.loadPromoBundles({
        'page[number]': page,
      });
    },
    async onDownloadStockExport() {
      this.loadingDownloadStockExport = true

      const [data,,res] = await this.request(`/api/v1/product-promos/${this.promo.data.id}/-actions/download-stock-export`, {
        responseType: 'blob'
      })
      const [,filename] = res.headers['content-disposition'].split('filename=')

      downloadFile(data, filename)

      this.loadingDownloadStockExport
    },
    setPromo(promo) {
      this.form.name = promo.data.attributes.name;
      this.form.description = promo.data.attributes.description;
      this.form.sc_start_at = formatDate(
        promo.data.attributes.sc_start_at,
        'YYYY-MM-DDTHH:mm'
      );
      this.form.sc_finish_at = formatDate(
        promo.data.attributes.sc_finish_at,
        'YYYY-MM-DDTHH:mm'
      );
      this.form.stockist_start_at = formatDate(
        promo.data.attributes.stockist_start_at,
        'YYYY-MM-DDTHH:mm'
      );
      this.form.stockist_finish_at = formatDate(
        promo.data.attributes.stockist_finish_at,
        'YYYY-MM-DDTHH:mm'
      );
      this.form.stock_export_at = formatDate(promo.data.attributes.stock_export_at, 'YYYY-MM-DDTHH:mm')

      this.promo = promo;
    },
  },
  created() {
    this.loadJobStatus();
    this.addListener();

    if (this.$route.params.id) {
      this.loadPromo(this.$route.params.id);
    }
  },
};
</script>
